
import { ApiProtocol, IgnoreError, assertRestResponse } from '@/components/easy'
import { toInteger } from 'lodash-es';

import { clearLoginState } from "utils/LogoutUtil";
import { Page } from "@/router/router-enum";
import router from '@/router'

const apiProtocol: ApiProtocol = {
	parseResponse: (data) => {
		return {
			success: !data.code,
			code: data.code,
			msg: data.message,
			data: data.data
		};
	},

	paginationRequest: async (
		axios,
		url,
		searchParams,
		paginationParams,
		config
	) => {
		const resp = await axios.post(
			url,
			{
				...(searchParams || {}),
				...(paginationParams
					? {
							pageNo: paginationParams.currentPage - 1,
							pageSize: paginationParams.pageSize
						}
					: {})
			},
			config
		).catch(e => {
			// jwt失效
			if(e.response.status == 401) {
				clearLoginState()
				router.replace(Page.LOGIN);
				throw new IgnoreError();
			}
			throw e;
		});

		const result = (assertRestResponse(resp) ||
			(paginationParams ? {} : [])) as any;

		// 分页模式下
		if (paginationParams) {
			const data = result || {};

			return {
				totalCount: toInteger(data.totalRows),
				data: data.result || []
			};
		}

		const data = result || [];

		// 非分页
		return {
			totalCount: data.length,
			data: data
		};
	}
}

export default apiProtocol;
